import React from 'react'
import PropTypes from 'prop-types'
import {Helmet} from 'react-helmet'

const Schema = ({regions, product}) => {
    const items = regions?.[0]?.components?.map((c) => c?.data).filter(Boolean) || []

    if (!product) {
        return null
    }

    const reviews = items
        .filter((item) => item.headlineText || item.bodyCopyText)
        .map((item) => ({
            '@type': 'Review',
            name: item.headlineText || undefined,
            reviewBody: item.bodyCopyText || item.headlineText || '',
            reviewRating: item.starRating
                ? {
                      '@type': 'Rating',
                      ratingValue: Number(item.starRating),
                      bestRating: '5',
                      worstRating: '1'
                  }
                : undefined,
            author: item.reviewerName ? {'@type': 'Person', name: item.reviewerName} : undefined
        }))

    const schema = {
        '@context': 'https://schema.org',
        '@type': 'Product',
        '@id': `${product.slugUrl}#product`,
        url: product.slugUrl,
        name: product.name,
        image:
            product?.imageGroups?.[0]?.images?.map((img) => img.disBaseLink).filter(Boolean) || [],
        sku: product.id,
        brand: {'@type': 'Brand', name: 'Kendra Scott'},
        aggregateRating:
            product.c_averageRating && product.c_reviewCount
                ? {
                      '@type': 'AggregateRating',
                      ratingValue: Number(product.c_averageRating).toFixed(1),
                      reviewCount: Number(product.c_reviewCount),
                      bestRating: '5',
                      worstRating: '1'
                  }
                : undefined,
        review: reviews.length ? reviews : undefined
    }

    if (!schema || Object.keys(schema).length === 0) {
        return null
    }

    return (
        <Helmet>
            <script type="application/ld+json">{JSON.stringify(schema)}</script>
        </Helmet>
    )
}

Schema.propTypes = {
    regions: PropTypes.arrayOf(
        PropTypes.shape({
            components: PropTypes.arrayOf(
                PropTypes.shape({
                    data: PropTypes.shape({
                        headlineText: PropTypes.string,
                        bodyCopyText: PropTypes.string,
                        reviewerName: PropTypes.string,
                        starRating: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
                    })
                })
            )
        })
    ),
    product: PropTypes.shape({
        slugUrl: PropTypes.string,
        name: PropTypes.string,
        id: PropTypes.string,
        c_averageRating: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        c_reviewCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        imageGroups: PropTypes.array
    })
}

export default Schema
